import { ColumnDef } from '@tanstack/react-table';

import Table from '../common/Table';
import { IPaginationTable } from '../common/interfaces/IPaginationTable';

import { ICollection } from '@/interfaces/api/collection/ICollection';
import { ICollectionHaggleEvent } from '@/interfaces/api/haggle-event/ICollectionHaggleEvent';
import { IHaggleWithAction } from '@/interfaces/api/haggle-event/IHaggleWithAction';

const UserHaggleEventsTable = ({
	collectionUserHaggleEvent,
	paginationOption,
	columns,
}: {
	collectionUserHaggleEvent: ICollectionHaggleEvent;
	paginationOption: IPaginationTable;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	columns: ColumnDef<IHaggleWithAction, any>[];
}) => {
	const handleCollectionWithAction = (
		collection: ICollectionHaggleEvent,
	): ICollection<IHaggleWithAction> => {
		return {
			...collection,
			data: collection.data.map((item) => ({
				...item,
				action: '',
			})),
		};
	};

	return (
		<div className="flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border rounded-md px-[2rem]">
			<h3 className="leading-5 font-medium py-[2rem] w-full text-[1.3rem]">
				Created Haggle Events
			</h3>
			<Table<IHaggleWithAction>
				collection={handleCollectionWithAction(collectionUserHaggleEvent)}
				columns={columns}
				paginationSection={paginationOption}
				tableStyles={{
					tableBox: 'w-full border-t overflow-y-auto h-70',
					table: 'w-full',
					tableBody: 'text-grey-50',
				}}
				dataTest="user-haggle-events-table"
			/>
		</div>
	);
};

export default UserHaggleEventsTable;
